import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Icons } from '@/assets/icons/icons';
import { YStack } from '@/components/ui/layout/layout';
import { SidebarRow } from '@/design-system-v2/sidebar-row';
import { codingAgentsStore } from '@/features/coding-agents';
import { FEATURES, hasFeature } from '@/features/feature-flags';
import { AppCapability, isCapable, isWindows } from '@/utils/capabilities';

import { PLUGINS_TAB_LABELS, pluginsStore } from './plugins.store';

const ROWS = [
  { tab: 'integrations', Icon: Icons.puzzle },
  { tab: 'skills', Icon: Icons.wandSparkles },
  { tab: 'coding-agents', Icon: Icons.terminal },
] as const;

// The hook script is POSIX sh, so coding agents are for macOS and Linux only
const canHookAgents = () =>
  isCapable(AppCapability.DesktopExclusive) && !isWindows();

export const PluginsSidebar = observer(() => {
  const featureOn = hasFeature(FEATURES.CODING_AGENTS);
  useEffect(() => {
    // A user who lost the feature still needs the row to disconnect an agent
    if (!featureOn && canHookAgents()) void codingAgentsStore.load();
  }, [featureOn]);
  const showsCodingAgents =
    canHookAgents() && (featureOn || codingAgentsStore.anyConnected);

  return (
    <YStack className="min-h-0 flex-1 gap-0.5 overflow-y-auto scrollbar-hide">
      {ROWS.filter(
        ({ tab }) => tab !== 'coding-agents' || showsCodingAgents
      ).map(({ tab, Icon }) => (
        <SidebarRow.Button
          key={tab}
          leading={<SidebarRow.Icon icon={Icon} />}
          selected={pluginsStore.activeTab === tab}
          onClick={() => pluginsStore.setActiveTab(tab)}
        >
          {PLUGINS_TAB_LABELS[tab]}
        </SidebarRow.Button>
      ))}
    </YStack>
  );
});
